<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
	<h4 class="modal-title" >{{TR "Betriebsart"}}</h4>
</div>
<div class="modal-body">
	{{!--  ### Verwendeter Modus ###  --}}
	{{#if showModeSettings}}
	<div class='row'>
		<div class="col-sm-3 col-xs-12 form-group form-group-vertical-padding">
			<button type="button" id="js-auto" class="js-mode btn btn-block
				{{EQ settings.mode_chosen 'auto' 'mode-selected'}}
				{{NEQ settings.mode_chosen 'auto' 'mode-not-selected'}}">{{modeConfigs.auto.text}}
				 <i class='{{modeConfigs.auto.icon}}'></i>
			</button>
		</div>
		<div class="col-sm-3 col-xs-12 form-group form-group-vertical-padding">
			<button type="button" id="js-day" class="js-mode btn btn-block
				{{EQ settings.mode_chosen 'day' 'mode-selected'}}
				{{NEQ settings.mode_chosen 'day' 'mode-not-selected'}}">{{modeConfigs.day.text}}
				<i class='{{modeConfigs.day.icon}}'></i>
			</button>
		</div>
		<div class="col-sm-3 col-xs-12 form-group form-group-vertical-padding">
			<button type="button" id="js-night" class="js-mode btn btn-block
				{{EQ settings.mode_chosen 'night' 'mode-selected'}}
				{{NEQ settings.mode_chosen 'night' 'mode-not-selected'}}">{{modeConfigs.night.text}}
				<i class='{{modeConfigs.night.icon}}'></i>
			</button>
		</div>
		<div class="col-sm-3 col-xs-12 form-group form-group-vertical-padding">
			<button type="button" id="js-standby" class="js-mode btn btn-block
				{{EQ settings.mode_chosen 'standby' 'mode-selected'}}
				{{NEQ settings.mode_chosen 'standby' 'mode-not-selected'}}">{{modeConfigs.standby.text}}
				<i class='{{modeConfigs.standby.icon}}'></i>
			</button>
		</div>
	</div>
	<div class='row'>
		{{#COMPARE settings.mode_chosen "!=" "auto"}}
		<div class="col-sm-12">
			<div class="pull-right p-t-20">
				<span class="m-r-15">
					{{TR "Automatik-Modus wird wieder aktiv:"}}
					<strong id="js-validity-time">
					{{#if auto_timer_string}}
						{{auto_timer_string}}
					{{else}}
						{{TR "bei Regler Neustart"}}
					{{/if}}
					</strong>
				</span>
				<button id="js-edit-validity" class="btn btn-white pull-right">
					<i class="glyphicon glyphicon-pencil"></i>
				</button>
				{{#if auto_timer_string}}
				<button id="js-clear-validity" class="btn btn-white pull-right">
					<i class="glyphicon glyphicon-trash"></i>
				</button>
				{{/if}}
			</div>
		</div>
		{{/COMPARE}}
	</div>
	{{!--  ### /Moduswahl ###  --}}
	{{/if}}
	{{#if is_holiday_possible}}
	{{!--  ### Urlaubsmodus ###  --}}
	<div class='row'>
		<div class='col-sm-12 p-b-10'>
			{{#unless settings.is_holiday}}<hr/>{{/unless}}
			<div class="widget-bg-color-icon">
				<div class="med-icon bg-icon-{{modeConfigs.holiday.color}} pull-right">
					<i class="text-{{modeConfigs.holiday.color}} {{modeConfigs.holiday.icon}}"></i>
				</div>
				<div class="text-left p-b-20">
					<h4 class="text-dark"><span class="counter">{{TR "Urlaub"}}</span></h4>
					<p class="text-muted">
					{{#unless settings.is_holiday}}
						{{TR "Urlaubs-Modus ist deaktiviert"}}
					{{/unless}}
					</p>
				</div>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
	<div class='row'>
		{{#if settings.is_holiday}}
		<div class="col-sm-12">
			<div class="pull-right p-t-20">
				<span class="m-r-15">
					{{TR "Urlaubs-Modus wird deaktiviert:"}}
					<strong id="js-validity-time">
					{{#if auto_timer_string}}
						{{auto_timer_string}}
					{{else}}
						{{TR "bei Regler Neustart"}}
					{{/if}}
					</strong>
				</span>
				<button id="js-edit-validity" class="btn btn-white pull-right">
					<i class="glyphicon glyphicon-pencil"></i>
				</button>
				{{#if auto_timer_string}}
				<button id="js-clear-validity" class="btn btn-white pull-right">
					<i class="glyphicon glyphicon-trash"></i>
				</button>
				{{/if}}
			</div>
		</div>
		{{/if}}
		<div class="col-xs-12">
			<button id="js-holiday" class="btn btn-default btn-block m-t-15"> <span>
			{{#if settings.is_holiday}}
				{{TR "Urlaubs-Modus deaktivieren"}}
			{{else}}
				{{TR "Urlaubs-Modus aktivieren"}}
			{{/if}}
			</span> </button>
		</div>
	</div>
	{{!--  ### /Urlaubsmodus ###  --}}
	{{/if}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button type="button" class="btn btn-primary" id="js-save">{{TR "Speichern"}}</button>
</div>
